import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import AppProvider from './context/Provider'
import reportWebVitals from './reportWebVitals'
import { BrowserRouter } from 'react-router-dom/cjs/react-router-dom.min'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <BrowserRouter>
    <AppProvider>
      <App />
    </AppProvider>
  </BrowserRouter>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
